import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
`

export const AppContainer = styled.div`
  position: relative;
  height: calc(100% - 56px);
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;

  @media (min-width: 0px) and (orientation: landscape) {
    height: calc(100% - 48px);
  }

  @media (min-width: 600px) {
    height: calc(100% - 64px);
  }
`

export const MainContainer = styled.main`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`
